import { render, staticRenderFns } from "./AdsControl.vue?vue&type=template&id=520f0ff6&"
import script from "./AdsControl.vue?vue&type=script&lang=js&"
export * from "./AdsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports